import { useCreateManualFormModal } from '~/components/Modals/ManualFormModal';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

export const usePurchaseByCustomerIdInputModal = () => {
  const navigation = useAppNavigation();

  return useCreateManualFormModal({
    title: translate('purchases.purchasesForCustomerId'),
    subtitle: translate('purchases.enterCustomerId'),
    formData: [
      {
        items: [
          {
            type: 'text',
            label: translate('purchases.customerId'),
            id: 'customerId',
          },
        ],
      },
    ],
    onConfirm: (value) => {
      navigation.navigate('PurchasesByCustomerId', value);
    },
  });
};
